import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import Header from "../../components/header/Header";
import Loading from "../../components/preloader/Loading";
import Map from "../../components/map/Map";
import ContentPanel from "./ContentPanel";
import InfoMessage from "../../components/infomessage/InfoMessage";
import VectorSource from "ol/source/Vector";
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import olWKT from "ol/format/WKT";
import GeoJSON from 'ol/format/GeoJSON';
import Feature from 'ol/Feature.js';
import Point from 'ol/geom/Point.js';
import { Style, Text, Fill, Stroke, Circle } from "ol/style.js";
import Icon from 'ol/style/Icon.js';
import httpClient from '../../services/HttpClient';
import * as turf from '@turf/turf'
import axios from 'axios';
import "./MainPage.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight, faMap } from "@fortawesome/free-solid-svg-icons";


class MainPage extends Component {
  state = {
    map: null,
    searchHeight: 52,
    zoomToDuration: 1000,
    contentHeight: window.innerHeight - 60,
    cardIsFullOpen: false,
    geometryCreationMode:'',
    vectorSource: null,
    searchVectorSource: null,
    buffer: '',
    rawFeatures: [],
    validatedFeature: null,
    projectName: '',
    extractLocation: '',
    parcelSelectionLoading: false,
    searchIsLoading: false,
    options: [],
    selected: [],
    infoMessage: '',
    isLoading: false,
    exportItems:[],
    exportFormats: [],
    exitOnClose: false
  };

  goBack = ()=>{
    const { rawFeatures, vectorSource, featureBackup } = this.state;
    vectorSource.clear();
    vectorSource.addFeatures(featureBackup);
    
    this.setState({
      validatedFeature: null,
      featureBackup: []
    })
  };

  updateMapSize = () => {
    this.setState({
      contentHeight: window.innerHeight - 60
    });
  };

  setMapReference = (map) => {
    this.setState({
      map: map
    });
  };

  showMap = () => {
    const { cardIsFullOpen } = this.state;
    this.setState({cardIsFullOpen:!cardIsFullOpen});
  };

  removeParcel = (parcel)=> {
    const { vectorSource } = this.state;
    vectorSource.removeFeature(parcel);
  };

  handleToggleFeatures = (features, doNotRemove) => {
    const { rawFeatures, vectorSource } = this.state;
    const wktFormat = new olWKT();
    features.forEach((item, index)=> {
      try {
        let wkt = wktFormat.writeGeometry(item.getGeometry());
        item.set('wkt',wkt);

        const existingFeature = rawFeatures.filter(feature=>feature.get('wkt')===wkt);
        if(existingFeature.length===0) {
          vectorSource.addFeature(item);
        } else if(!doNotRemove) {
          vectorSource.removeFeature(existingFeature[0]);
        }
      } catch (error) {
        console.error(error);
      }
    });
  }

  mapClickHandler = event => {
    const { geometryCreationMode, validatedFeature, map } = this.state;

    const that = this;
    if(!validatedFeature && geometryCreationMode==='SelectParcels' && Array.isArray(event.coordinate) && event.coordinate.length===2) {
      
      let findParcel = () => {
        let features = [];
        map.forEachFeatureAtPixel(event.pixel, function(feature, layer) {
          const isDuplicate = features.some(obj => obj.get("PARCEL_NO") === feature.get("PARCEL_NO"));
          if (!isDuplicate) {
            features.push(feature);
          }
        });
        that.handleToggleFeatures(features);
        this.setState({parcelSelectionLoading:false});
      }

      this.setState({parcelSelectionLoading:true},findParcel);
    }
    
  };

  handleSearch = (search) => {
    const that = this;
    axios.get(`${window.clipship_config.AddressGeolocatortUrl}/suggest?text=${search}&maxSuggestions=10&f=pjson`)
      .then(function (response) {
        if(!!response && !!response.data && Array.isArray(response.data.suggestions)) {
          response.data.suggestions.forEach( suggestion => suggestion.isSuggestion = true );
          that.setState({options: response.data.suggestions});
        }
      })
      .catch(function (error) {
        that.setInfoMessage('Error','Search failed.  Please try again.');
      });
  };

  onSearchResultSelected = (features) => {
    const that = this;
    if( features[0].isSuggestion ) {
      axios.get(`${window.clipship_config.AddressGeolocatortUrl}/findAddressCandidates?outSR=3857&magicKey=${features[0].magicKey}&f=pjson`)
      .then(function (response) {
        if(!!response && !!response.data && Array.isArray(response.data.candidates) && !!response.data.candidates[0].extent) {
          const extent = response.data.candidates[0].extent;
          that.zoomToExtent([
            extent.xmin,
            extent.ymin,
            extent.xmax,
            extent.ymax
          ]);
          const location = response.data.candidates[0].location;
          that.addTemporaryMarker(location.x, location.y);
        }
      })
      .catch(function (error) {
        that.setInfoMessage('Error','Search failed.  Please try again.');
      });
    } else {
      const { geometryCreationMode, validatedFeature } = this.state;
      if(geometryCreationMode==='SelectParcels' && !validatedFeature) {
        this.handleToggleFeatures(features,true);
      }
      const extent = features[0].getGeometry().getExtent();
      this.zoomToExtent(extent);
      that.addTemporaryMarker((extent[0]+extent[2])/2, (extent[1]+extent[3])/2);
    }
  };

  renderSearchResults = (option, props) => {
    if( option.isSuggestion ) {
      return (
        <span>{option.text}</span>
      );
    } else {
      return (
        <span>{option.get('PARCEL')}{!option.get('ADDRESS1') ? ' ' : ' - ' }{option.get('ADDRESS1')}</span>
      );
    }
  };

  getSearchLabelKey = (option) => {
    if( option.isSuggestion ) {
      return option.text;
    } else {
      return option.get('PARCEL');
    }
  };

  
  addTemporaryMarker = (long, lat) => {
    const { searchVectorSource, zoomToDuration } = this.state;

    const iconFeature = new Feature({
      geometry: new Point([long, lat])
    });
    
    const iconStyle = new Style({
      image: new Icon({
        anchor: [0.5, 60],
        anchorXUnits: 'fraction',
        anchorYUnits: 'pixels',
        src: 'data:image/png;base64,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'      
      })
    });

    iconFeature.setStyle(iconStyle);

    searchVectorSource.clear();

    setTimeout(()=>{
      searchVectorSource.addFeature(iconFeature);
    },zoomToDuration+200);
  };
  
  
  zoomToExtent = (extentArr) => {
    const { map, zoomToDuration } = this.state;
    const that  = this;
    if(!!map) {
      extentArr[0] = extentArr[0] > -20037508.34 ? extentArr[0] : -20037508.34;
      extentArr[1] = extentArr[1] > -20037508.34 ? extentArr[1] : -20037508.34;
      extentArr[2] = extentArr[2] < 20037508.34 ? extentArr[2] : 20037508.34;
      extentArr[3] = extentArr[3] < 20037508.34 ? extentArr[3] : 20037508.34;


      const mapSize = map.getSize();
      map
        .getView()
        .fit(extentArr, { size: mapSize, duration: zoomToDuration, maxZoom: 18 });
    }
  };

  getConfigInfo = async() => {
    const apiBaseUrl = window.clipship_config.ApiBaseUrl;
    let that = this;

    const exportTypesRequest = httpClient.get(`${apiBaseUrl}/exporttype`);
    const exportFormatsRequest = httpClient.get(`${apiBaseUrl}/exportformat`); 

    Promise.all([exportTypesRequest, exportFormatsRequest])
    .then(([exportTypesResponse, exportFormatsResponse]) => {
      if (!!exportTypesResponse && !!exportTypesResponse.data && Array.isArray(exportTypesResponse.data) &&
        !!exportFormatsResponse && !!exportFormatsResponse.data && Array.isArray(exportFormatsResponse.data)
      ) {
        const exportTypes = exportTypesResponse.data.map(obj => ({
          ...obj,
          Selected: obj.default_selection,
        }));

        const exportFormats = exportFormatsResponse.data.map(obj => ({
          ...obj,
          Selected: obj.default_selection,
        }));
        that.setState({ 
          exportItems: exportTypes,
          exportFormats: exportFormats,
          isLoading: false
        });
      } else {
        that.setInfoMessage('Error', 'Failed to get required data. Please try reloading the page and if the issue persists contact us.');
      }
    })
    .catch((error) => {
      that.setInfoMessage('Error', 'Failed to get required data. Please try reloading the page and if the issue persists contact us.');
    });

  };

  componentDidMount() {
    window.addEventListener('resize', this.updateMapSize);

    const vectorSource = new VectorSource();
    const searchVectorSource = new VectorSource();

    vectorSource.on('addfeature',e=>{
      if(!e.feature.get('isValidated')) {
        const { rawFeatures } = this.state;
        let newFeatures = [...rawFeatures];
        const wktFormat = new olWKT();
        let wkt = wktFormat.writeGeometry(e.feature.getGeometry());
        e.feature.set('wkt',wkt);

        const existingFeature = rawFeatures.filter(feature=>feature.get('wkt')===wkt);
        if(existingFeature.length===0) {
          newFeatures.push(e.feature);
        }
        this.setState({
          rawFeatures: vectorSource.getFeatures()
        });
      }
    });
    vectorSource.on('removefeature',e=>{
      const { rawFeatures } = this.state;
      const wktFormat = new olWKT();
      let wkt = wktFormat.writeGeometry(e.feature.getGeometry());

      let newFeatures = rawFeatures.filter(item=>item.get('wkt')!==wkt);
      this.setState({
        rawFeatures: vectorSource.getFeatures()
      });
    });
    vectorSource.on('clear',e=>{
      this.setState({
        rawFeatures: []
      });
    });

    this.setState({
      vectorSource: vectorSource,
      searchVectorSource: searchVectorSource,
      isLoading: true
    }, () => {
      this.getConfigInfo();
    });
  };

  setBuffer = (buffer) => {
    this.setState({buffer:Number(buffer)});
  };

  setProjectName = (projectName) => {
    this.setState({projectName});
  };

  setExtractLocation = (extractLocation) => {
    this.setState({extractLocation});
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateMapSize);
  };
  
  useCurrentGeometry = ()=> {
    const { rawFeatures, buffer, vectorSource } = this.state;

    let unionFeature = null;
    let geomError = false;

    rawFeatures.forEach(item=>{
      let feature = new GeoJSON({dataProjection:'EPSG:4326',featureProjection:'EPSG:3857'}).writeFeatureObject(item);
      if(unionFeature===null) {
        unionFeature = {...feature};
      } else {
        try {
          //Try to union the features
          unionFeature = turf.union(unionFeature, feature);
        } catch (error) {
          try {
            //If this fails try to fix the bad geometry by simplifying it before the union
            console.log('There was an issue unioning the following parcel feature.  The application will attempt to simplify and union it again.');
            console.log(JSON.stringify(feature));

            //The tolerance of 0.000001 degrees should be less than 0.328084 feet
            const simplifyOptions = {tolerance: 0.000001, highQuality: false};
            const simplified = turf.simplify(feature, simplifyOptions);
            unionFeature = turf.union(simplified, feature);
          } catch (error) {
            //If all of this fails let the user know there is a parcel with a bad geom
            geomError = true;
            this.setInfoMessage('Error',`There is something invalid about one of the selected parcel geometries.  Either select other parcels or draw the polygon instead.`);
            return;
          }
        }
      }
    });

    if(!geomError) {
      let bufferFeatureGeoJson = turf.buffer(unionFeature, Number(buffer), {units:'feet', steps: 1 });
      
      //Validate here
      const area = turf.area(bufferFeatureGeoJson);
      const wktFormat = new olWKT();
      let featureNew = new GeoJSON({dataProjection:'EPSG:4326',featureProjection:'EPSG:3857'}).readFeature(bufferFeatureGeoJson);
      const wkt = wktFormat.writeGeometry(featureNew.getGeometry(), {
        //https://en.wikipedia.org/wiki/Decimal_degrees
        decimals: 6 //The 6 decimal places should be less than 100mm in the US.  This should be enough precision to unambiguously recognized individual humans
      });
      //console.log(wkt)
      if(area > window.clipship_config.ClipAreaMaxSizeSqMeter) {
        const reductionPercent = Math.ceil(((area - window.clipship_config.ClipAreaMaxSizeSqMeter) / window.clipship_config.ClipAreaMaxSizeSqMeter)*100);
        this.setInfoMessage('Error',`The selected clip area is too large.  Please reduce the size by ${reductionPercent}% before continuing.`);
      } else if(wkt.length > 3800) {
        //This is to deal with the Oracle varchar limit of 4000
        this.setInfoMessage('Error',`There are too many points in your selected area.  Please create a simpler selected area before continuing.`);
      } else {
        featureNew.set('isValidated',true);
        vectorSource.clear();
        vectorSource.addFeature(featureNew);
        this.zoomToExtent(featureNew.getGeometry().getExtent());

        this.setState({
          validatedFeature: featureNew,
          featureBackup: [...rawFeatures]
        });
      }
    }
  };

  clearCurrentGeometry = () => {
    const { vectorSource } = this.state;
    vectorSource.clear();
  };

  clearInfoMessage = ()=> {
    const { exitOnClose } = this.state;
    if(!exitOnClose) {
      this.setState({infoHeader:'', infoMessage:''});
    } else {
      window.location.reload(true);
    }
  };

  setInfoMessage = (infoHeader, infoMessage, exitOnClose)=> {
    this.setState({infoHeader:infoHeader, infoMessage: infoMessage, exitOnClose: exitOnClose, isLoading: false});
  };

  setLoading = (isLoading, callback) => {
    this.setState({isLoading:isLoading},()=>{
      if(!!callback) {
        callback();
      }
    });
  };

  setExportItems = (id) => {
    const updatedCheckboxes = this.state.exportItems.map(item => {
      if (item.id === id) {
        return { ...item, Selected: !item.Selected };
      }
      return item;
    });
    this.setState({exportItems: updatedCheckboxes}); // Assuming you're using useState for checkboxes
  };

  setExportFormats = (id) => {
    const updatedCheckboxes = this.state.exportFormats.map(item => {
      if (item.id === id) {
        return { ...item, Selected: !item.Selected };
      }
      return item;
    });
    this.setState({exportFormats: updatedCheckboxes}); // Assuming you're using useState for checkboxes
  };

  render() {
    const { contentHeight, cardIsFullOpen, geometryCreationMode, vectorSource, searchVectorSource, rawFeatures, buffer, 
      validatedFeature, projectName, extractLocation, searchHeight,
      searchIsLoading, selected, options, parcelSelectionLoading, map, infoMessage, isLoading, exportItems, exportFormats } = this.state;

    return (
      <>
        <Header />
        <Loading isOpen={isLoading} />
        <InfoMessage infoMessage={infoMessage} clearMessage={this.clearInfoMessage} />
        <div className="main-container">
          <Row className="content g-0">
            <Col
              style={{paddingLeft:'0px',paddingRight:'0px', height: contentHeight, overflowY: 'auto',
                borderRightColor: '#d1d1d1', borderRightWidth: 2, borderRightStyle: 'solid'
              }}
              id="mysidebar"
              className={cardIsFullOpen ? "sidebar" : ""}
              md={cardIsFullOpen ? 0 : 5}
            >
              <ContentPanel 
                geometryCreationMode={geometryCreationMode}
                setSelectParcels={()=>{
                  vectorSource.clear();
                  this.setState({geometryCreationMode:'SelectParcels'});
                }} 
                setDrawPolygon={()=>{
                  vectorSource.clear();
                  this.setState({geometryCreationMode:'DrawPolygon'});
                }}
                map={map}
                rawFeatures={rawFeatures}
                exportItems={exportItems}
                setExportItems={this.setExportItems}
                exportFormats={exportFormats}
                setExportFormats={this.setExportFormats}
                zoomToExtent={this.zoomToExtent}
                removeParcel={this.removeParcel}
                goBack={this.goBack}
                useCurrentGeometry={this.useCurrentGeometry}
                clearCurrentGeometry={this.clearCurrentGeometry}
                buffer={buffer}
                setBuffer={this.setBuffer}
                validatedFeature={validatedFeature}
                projectName={projectName}
                setProjectName={this.setProjectName}
                extractLocation={extractLocation}
                setExtractLocation={this.setExtractLocation}
                parcelSelectionLoading={parcelSelectionLoading}
                setLoading={this.setLoading}
                setInfoMessage={this.setInfoMessage}  />
            </Col>
            <Col md={cardIsFullOpen ? 12 : 7} id="right-side">
              {/*<Button className="button-for-sideBar" style={{top:contentHeight/2}} onClick={this.showMap}>
                <FontAwesomeIcon
                  icon={cardIsFullOpen ? faArrowRight : faArrowLeft}
                />
              </Button>{" "}*/}
              <div style={{height:searchHeight}}>
                <div style={{float:'left', fontSize: 22, paddingTop: 6, paddingRight: 10, paddingLeft: 10}}>Search</div>
                <AsyncTypeahead
                  style={{width:'100%', paddingTop: 5, paddingRight:10}}
                  filterBy={()=>true}
                  id="parcel-search"
                  isLoading={searchIsLoading}
                  selected={selected}
                  labelKey={this.getSearchLabelKey}
                  minLength={2}
                  onChange={this.onSearchResultSelected}
                  onSearch={this.handleSearch}
                  delay={1000}
                  options={options || []}
                  placeholder="Search for an address..."
                  renderMenuItemChildren={this.renderSearchResults}
                />
              </div>
              <Map 
                mapHeight={contentHeight-searchHeight} 
                cardIsFullOpen={cardIsFullOpen} 
                geometryCreationMode={geometryCreationMode} 
                validatedFeature={validatedFeature}
                vectorSource={vectorSource} 
                searchVectorSource={searchVectorSource}
                rawFeatures={rawFeatures}
                mapClickHandler={this.mapClickHandler}
                setMapReference={this.setMapReference}
                />
            </Col>
          </Row>
        </div>
      </>
    );
  }
}


export default MainPage;
